import React from "react";
import "./Footer.css";
import { useTranslation } from "react-i18next";

const Footer = ({ variant = "gradient" }) => {
  const { t } = useTranslation();
  return (
    <footer className={`footer ${variant === "plain" ? "footer--plain" : ""}`}>
      <div className="divider"></div>
      <div className="footer-content">
        <div className="contact-info">
          <span className="copyright">2025 | Gandolapp, S.L.</span>
        </div>
        <div className="contact-info">
          <a
            href="/Política_de_Privacidad___Privacy_Policy.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            {t("footer.privacyPolicy")}
          </a>
        </div>
        <div className="contact-info">
          <a
            href="/Términos_y_Condiciones_de_Uso___Terms_and_Conditions_of_Use.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            {t("footer.termsAndConditions")}
          </a>
        </div>
        <div className="contact-info">
          <a
            href="https://gandolapp.com"
            target="_blank"
            rel="noopener noreferrer"
            className="footer-link"
          >
            {t("footer.website")}
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
